





























export default {
    name: 'CoProgressBar',
    props: {
        current: {
            type: Number,
            required: false,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
            required: false,
        },
        valueLabelType: {
            type: String,
            default: 'absolute',
            required: false,
            validator(val) {
                return ['absolute', 'percentage', 'none'].indexOf(val) !== -1;
            },
        },
        valueLabelPosition: {
            type: String,
            default: 'inside',
            required: false,
            validator(val) {
                return ['inside', 'outside'].indexOf(val) !== -1;
            },
        },
        percentageRoundto: {
            type: Number,
            default: 0,
            required: false,
        },
    },
    computed: {
        percentageValue(): number {
            if (!this.total || this.total <= 0) return 0;
            const ratio = this.current / this.total;
            const clamped = Math.max(0, Math.min(1, ratio));
            // remove error for floating point precision issues like 87 becoming 86.9999999
            const epsilon = 0.000001;
            if (clamped > 0 && clamped < epsilon) {
                return 0;
            }
            return clamped * 100;
        },
        progressWidth() {
            return `${this.percentageValue}%`;
        },
        labelOutsideWidth() {
            // calculate based on total digits
            if (this.valueLabelType === 'percentage') {
                return `${3 * 0.6 + 1}rem`;
            }
            const totalDigitsAbsolute = this.total.toString().length;
            return `${totalDigitsAbsolute * 0.6}rem`;
        },
    },
};
